import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import data from './modules/data'

Vue.use(Vuex);

export const store = new Vuex.Store({
    modules: {
        user,
        data
    },
    state: {
        
    },
    mutations: {

    },
});


// WEBPACK FOOTER //
// ./src/store/store.js